import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className='text-white w-full mt-24 border-t' style={{background: 'rgba(255,255,255,0.02)', borderColor: 'rgba(255,255,255,0.06)'}}>
            {/* Legal disclaimer */}
            <div className='px-6 py-8 border-b text-center' style={{borderColor: 'rgba(255,255,255,0.05)'}}>
                <p className='text-xs text-gray-400 leading-relaxed max-w-3xl mx-auto mb-2'>
                    Digipayments SAU es un Proveedor de Servicios de Pago que ofrece Cuentas de Pago. No está autorizada por el BCRA para operar como Entidad Financiera.
                </p>
                <p className='text-xs text-gray-500 leading-relaxed max-w-3xl mx-auto'>
                    Los fondos depositados en cuentas de pago no constituyen depósitos en una entidad financiera, ni cuentan con ninguna de las garantías que tales depósitos puedan gozar de acuerdo con la legislación y reglamentación aplicables en materia de depósitos en entidades financieras.
                </p>
            </div>

            {/* Contact info */}
            <div className='px-6 py-6 border-b' style={{borderColor: 'rgba(255,255,255,0.05)'}}>
                <p className='text-xs font-semibold text-gray-300 text-center mb-4 tracking-wide uppercase'>Responsables ante el BCRA — Servicio de Atención al Usuario</p>
                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 text-center'>
                    <div className='text-xs text-gray-400'>
                        <span className='block text-gray-500 mb-1'>Titular</span>
                        Yamila Perdiguero<br/>
                        <span className='text-gray-500'>responsable@digipayments.com.ar</span>
                    </div>
                    <div className='text-xs text-gray-400'>
                        <span className='block text-gray-500 mb-1'>Suplente</span>
                        Pablo Cabiati<br/>
                        <span className='text-gray-500'>manager@digipayments.com.ar</span>
                    </div>
                    <div className='text-xs text-gray-400'>
                        <span className='block text-gray-500 mb-1'>Domicilio</span>
                        Bouchard 680, piso 19<br/>
                        <span className='text-gray-500'>CABA</span>
                    </div>
                    <div className='text-xs text-gray-400'>
                        <span className='block text-gray-500 mb-1'>Teléfono</span>
                        0800-220-0510
                    </div>
                    <div className='text-xs text-gray-400'>
                        <span className='block text-gray-500 mb-1'>Soporte</span>
                        soporte@digipayments.com.ar
                    </div>
                </div>
            </div>

            {/* Bottom bar */}
            <div className='px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-4'>
                <p className='text-xs text-gray-500'>© 2023–2026 Digipayments. Todos los derechos reservados.</p>

                <div className='flex items-center justify-center'>
                    <Link to="https://www.argentina.gob.ar/aaip/datospersonales/reclama/30716951789--RL-2022-59797587-APN-DNPDP#AAIP" target='_blank'>
                        <img src="https://www.argentina.gob.ar/sites/default/files/aaip-isologo.png" alt="AAIP RNBD" style={{width: '80px', border: '0', opacity: 0.7}} className='hover:opacity-100 transition-opacity duration-200'/>
                    </Link>
                </div>

                <div className='flex items-center gap-4 text-xs'>
                    <span className='flex items-center gap-1 text-gray-400 hover:text-white transition-colors duration-200'>
                        <a target='_blank' href='/terms-and-conditions' className='border-b border-gray-600 hover:border-gray-300 transition-colors duration-200'>Contratos de adhesión</a>
                        <Link to='/Terminos y Condiciones Generales Digipayments.pdf' target='_blank' download>
                            <i className='bx bxs-file-pdf text-xl ml-1 text-gray-500 hover:text-red-400 transition-colors duration-200 cursor-pointer'></i>
                        </Link>
                    </span>
                    <span className='text-gray-700'>|</span>
                    <span className='flex items-center gap-1 text-gray-400 hover:text-white transition-colors duration-200'>
                        <a target='_blank' href="/privacy-policy" className='border-b border-gray-600 hover:border-gray-300 transition-colors duration-200'>Políticas de privacidad</a>
                        <Link to='/Politica de Privacidad Digipayments.pdf' target='_blank' download>
                            <i className='bx bxs-file-pdf text-xl ml-1 text-gray-500 hover:text-red-400 transition-colors duration-200 cursor-pointer'></i>
                        </Link>
                    </span>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
